import { Injectable } from '@angular/core';
import { DataService } from '../../../shared/services/data/data.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class StepsBuilderDataService {

  apiUrlSuffix = 'step-graph'
  apiUrl = `${environment.studioApiUrl}/${this.apiUrlSuffix}`
  publishActionsApiUrlSuffix = 'publish'
  publishActionsApiUrl = `${environment.studioApiUrl}/${this.publishActionsApiUrlSuffix}`;
  private generatedDSS : any;
  public dataService: DataService;

  constructor(dataService: DataService) { 
    this.dataService = dataService;
  }

  set setGeneratedDSS(data) {
    this.generatedDSS = data;
  }

  uploadDataSourceInfo({ userId, sourceType, data, ...metadata}) {
    const option = {
      url: `${this.apiUrl}/upload-datasource-info/${userId}/${sourceType}`,
      data: data
    } 
    return this.dataService.post(option);
  }

  initStepGraph({ userId, sourceType, ...metadata}) {
    const option = {
      url: `${this.apiUrl}/init-step-graph/${userId}/${sourceType}`
    } 
    return this.dataService.get(option);
  }

  updateStepGraph({ userId, sourceType, data,  ...metadata}) {
    const option = {
      url: `${this.apiUrl}/upload-step-graph-commands/${userId}/${sourceType}`,
      data: data
    } 
    return this.dataService.post(option);
  }

  getGeneratedDSS({userId, sourceType}) {
    const option = {
      url: `${this.publishActionsApiUrl}/generate-dss/${userId}/${sourceType}`,
    }
    return this.dataService.get(option);
  }

  publishConnector(userId, sourceType) {
    let data = {
      "userId": userId,
      "dataSourceType": sourceType,
      "settings": this.generatedDSS || {}
    }
    const option = {
      url: `${this.publishActionsApiUrl}/publish-dss`,
      data: data
    } 
    return this.dataService.post(option);
  }

}